import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import InAppNotificationService from "@/services/notifications/in-app-notification.service";

export const UNREAD_COUNT_QUERY_KEY = ["in-app-notifications-unread-count"];
export const IN_APP_NOTIFICATIONS_QUERY_KEY = ["in-app-notifications"];

export const useUnreadNotificationCount = () => {
  return useQuery({
    queryKey: UNREAD_COUNT_QUERY_KEY,
    queryFn: () => InAppNotificationService.getUnreadCount(),
    refetchOnWindowFocus: true,
    refetchInterval: 60000,
  });
};

export const useInAppNotifications = (params: {
  page?: number;
  limit?: number;
  unreadOnly?: boolean;
} = {}) => {
  return useQuery({
    queryKey: [...IN_APP_NOTIFICATIONS_QUERY_KEY, params],
    queryFn: () => InAppNotificationService.getNotifications(params),
    refetchOnWindowFocus: true,
    refetchInterval: 60000,
  });
};

export const useMarkNotificationsRead = () => {
  const queryClient = useQueryClient();

  return useMutation<{ updated: number }, Error, string[] | undefined>({
    mutationFn: (ids) => InAppNotificationService.markRead(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_QUERY_KEY });
      queryClient.invalidateQueries({
        queryKey: IN_APP_NOTIFICATIONS_QUERY_KEY,
      });
    },
  });
};
